import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  Text,
  Button,
  Input,
  Spinner,
  Div
} from "ui";
import { Container } from "./styled";

import useResponsive from "utils/hooks/useResponsive";


const Index = () => {
  const { t, i18n } = useTranslation();

  const { isMobile } = useResponsive()

  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);
  const [inputError, setInputError] = useState("");
  const [loading, setLoading] = useState(false);
  const [subscribeOk, setSubscribeOk] = useState(false);

  const regexEmail = /^(\w+[/./-]?){1,}@[a-z]+[/.]\w{2,}$/;


  const isSpanish = i18n.language === "es"

  const config = {
    formKey: isSpanish
      ? process.env.REACT_APP_FORMKEY_DATACRUSH_ES
      : process.env.REACT_APP_FORMKEY_DATACRUSH_EN,
    contactKey: isSpanish
      ? "591a6234-5eef-4541-a978-410544c7dff6"
      : "5b670b1e-aaed-49aa-b838-429cfc743553",
    sessionId: isSpanish
      ? "h19t0t7mqrtri0ap1jd0m48ja5"
      : "kokfss8o1ae69qu29ap8mfihqo",
  };

  const errorString = (error) => {
    if (isSpanish) return error;

    if (error === "El campo es obligatorio") {
      return "The field is required";
    } else if (error === "Ingrese un email valido") {
      return "Enter a valid email";
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setInputError("");

    if (!email.trim()) {
      return setInputError(errorString("El campo es obligatorio"));
    }

    if (!regexEmail.test(email.trim())) {
      return setInputError(errorString("Ingrese un email valido"));
    }

    setLoading(true);

    const formData = new FormData();

    formData.append("email", email);
    formData.append("portalID", "304");
    formData.append("form_key", config.formKey);
    formData.append("type", "embed");
    formData.append("contact_key", config.contactKey);
    formData.append("uid", "3a89c865-e2d9-4079-9ce2-68bfa4e61171");
    formData.append("source_type", "direct_traffic");
    formData.append("session_id", config.sessionId);

    const handleSucces = () => {
      setError(false);
      setLoading(false);
      setEmail("");
      setSubscribeOk(true);
    };

    // const handleLoading = () => {
    //   setError(false);
    //   setLoading(true);
    // };

    const request = new XMLHttpRequest();
    // request.upload.addEventListener("progress", handleLoading);
    request.upload.addEventListener("load", handleSucces);
    request.upload.addEventListener("error", () => setError(true));
    request.open("POST", "https://app.datacrush.la/apps/web/form/post");
    request.send(formData);
  };

  useEffect(() => {
    if (!subscribeOk) return

    setTimeout(() => {
      setSubscribeOk(false)
    }, 5000);
  }, [subscribeOk])


  if (loading) return (
    <Container>
      <Spinner size={40} />
    </Container>
  )

  if (subscribeOk) return (
    <Container>
      <Text weight="semibold" color='headline'>
        <span style={{ color: 'white' }}>
          {t("subscribeSuccess")}
        </span>
      </Text>
    </Container>
  )

  return (
    <Container>
      <Text weight="semibold" color='headline'>
        <span style={{ color: 'white' }}>
          {t("subscribeToOurNewsletter")}
        </span>
      </Text>

      <form
        onSubmit={handleSubmit}
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: 10,
          width: '100%',
          marginTop: 20
        }}
      >
        <Input.Text
          placeholder={t("email")}
          onChange={(val) => {
            setEmail(val)
            setInputError('')
          }}
          value={email}
        />
        <Button size='large' isFull={isMobile}>
          {t("subscribe")}
        </Button>
      </form>

      <Div width='100%'>
        {error && <Text color='error'>{t("subscribeError")}</Text>}
        {inputError.length > 0 && <Text color='error'>{inputError}</Text>}
      </Div>
    </Container>
  );
};

export default Index;
